import { SET_TRANSACTION_REQUEST_DROPDOWN_VALUE } from "../action";

export function setTransactionRequestDropdownValue(domainName, domainValue) {
  return (dispatch) => {
    dispatch({
      type: SET_TRANSACTION_REQUEST_DROPDOWN_VALUE,
      payload: { domainName, domainValue },
    });
  };
}
